import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //所有的任务列表
    list: [],
    inputValue: '',
    id: 5,
    viewKey: 'all',
    // 金币
    price: null,
    // 手机号
    phone: null,
  },
  mutations: {
    initList (state, list) {
      state.list = list
    },
    setInputValue (state, val) {
      state.inputValue = val
    },
    addItems (state) {
      const obj = {
        id: state.id,
        info: state.inputValue.trim(),
        done: false
      }
      state.list.push(obj)
      state.id++
      state.inputValue = ''
    },
    removeItem (state, id) {
      const i = state.list.findIndex((item) => item.id == id)
      if (i !== -1) {
        state.list.splice(i, 1)
      }
    },
    changeState (state, param) {
      const i = state.list.findIndex((item) => item.id == param.id)
      if (i !== -1) {
        state.list[i].done = param.status
      }
    },
    clearItems (state) {
      const newList = state.list.filter(item => item.done == false)
      state.list = newList
    },
    changeViewKey (state, key) {
      state.viewKey = key
    }
  },
  actions: {},
  getters: {},
  modules: {}
})
